var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgFilterOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23932 6.40033L10.6354 1.81522C10.6838 1.74988 10.6972 1.69636 10.6996 1.65414C10.7023 1.60659 10.6918 1.55051 10.6621 1.49391C10.6047 1.38463 10.4936 1.3 10.3202 1.3H1.67974C1.50898 1.3 1.39799 1.38288 1.3398 1.49017C1.30973 1.54561 1.29839 1.60088 1.30018 1.64817C1.30179 1.69041 1.31401 1.74336 1.35932 1.80804L4.59944 6.43405C4.84614 6.78626 4.98048 7.20661 4.98048 7.6401V10.4099L6.8255 9.47036V7.6519C6.8255 7.199 6.97211 6.76111 7.23932 6.40033ZM4.90737 11.906L7.67551 10.4964C7.95211 10.3555 8.1255 10.0767 8.1255 9.77263V7.6519C8.1255 7.48036 8.18095 7.31319 8.28398 7.17408L11.6801 2.58897C12.4802 1.50871 11.6877 0 10.3202 0H1.67974C0.332291 0 -0.464854 1.46965 0.294527 2.55384L3.53465 7.17985C3.62966 7.31549 3.68048 7.47589 3.68048 7.6401V11.1822C3.68048 11.7958 4.34913 12.1902 4.90737 11.906Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOutlined);
export default __webpack_public_path__ + "static/media/filterOutlined.9ff365d7d0be59d89eb21e6d1b681e6f.svg";
export { ForwardRef as ReactComponent };